import { keepPreviousData, useQuery } from "@tanstack/react-query";
import i18n from "i18n";
import { defaultOnError } from "util/conditional/onError";
import useUserDateTime from "hooks/useUserDateTime";
import { fetchUsage } from "ai-management/token-usage/api/tokenUsageApi";
import toUsageRequest from "ai-management/token-usage/usageRequest";
const useTokenUsage = (search) => {
  const { userTimezone } = useUserDateTime();
  const request = toUsageRequest(search, userTimezone);
  const { data, isLoading, isFetching } = useQuery({
    queryKey: ["ai-management", "token-usage", request],
    queryFn: () => defaultOnError(
      fetchUsage(request),
      i18n.t("notifications.token_usage_load_message", { ns: "enterprise_ai" }),
      i18n.t("notifications.token_usage_load_title", { ns: "enterprise_ai" })
    ),
    // Keeps the page from flashing while a new search loads; the search button shows the progress instead.
    placeholderData: keepPreviousData
  });
  return { data, isLoading, isFetching };
};
export default useTokenUsage;
